/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PortfolioReportReason = {
    InappropriateContent: 'INAPPROPRIATE_CONTENT',
    Harassment: 'HARASSMENT',
    IllegalActivities: 'ILLEGAL_ACTIVITIES',
    Plagiarism: 'PLAGIARISM',
    Impersonation: 'IMPERSONATION',
    CopyrightInfringement: 'COPYRIGHT_INFRINGEMENT',
    Spam: 'SPAM',
    Scam: 'SCAM',
    PrivateInformation: 'PRIVATE_INFORMATION',
    Other: 'OTHER'
} as const;
export type PortfolioReportReason = typeof PortfolioReportReason[keyof typeof PortfolioReportReason];


export function instanceOfPortfolioReportReason(value: any): boolean {
    for (const key in PortfolioReportReason) {
        if (Object.prototype.hasOwnProperty.call(PortfolioReportReason, key)) {
            // @ts-ignore
            if (PortfolioReportReason[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PortfolioReportReasonFromJSON(json: any): PortfolioReportReason {
    return PortfolioReportReasonFromJSONTyped(json, false);
}

export function PortfolioReportReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioReportReason {
    return json as PortfolioReportReason;
}

export function PortfolioReportReasonToJSON(value?: PortfolioReportReason | null): any {
    return value as any;
}

